// extracted by mini-css-extract-plugin
module.exports = {"a11m02ot":"a11m02ot","publisher-follow":"publisher-follow","secondary":"secondary"};